@if(matbeskedVM$ | async; as vm){
<h4>
    Mätbesked Viol
</h4>
<div class="row">
    <div class="col-3">
        <rask-button
        class="hamta-matbesked"
        [disabled]="vm.awaitingMatbesked || !vm.matbesked.avtalsobjekt"
        (click)="hamtaMatbeskedClick()"
        color="secondary">
        Hämta mätbesked
        @if(vm.awaitingMatbesked){
        <rask-busy-spinner class="ms-1" size="1"></rask-busy-spinner>
        }
    </rask-button>
    <span class="matbesked-senaste">{{vm.matbesked.senastHamtad | date: "yyyy-MM-dd hh:mm:ss"}}</span>
    </div>
    @if(!vm.isRotpost){
        <div class="col-9 matbesked-senaste">
            <rask-action-button [disabled]="vm.requestingMatbesked || !vm.matbesked.avtalsobjekt" (click)="skapaMatbeskedClick()" icon="fas fa-plus" aid="buttonAddOrderrad">
                Skapa mätbesked <rask-info class="matbesked-info">Mätbesked skapas och skickas alltid av Biometria till leverantör ca 2 veckor efter sista inmätningen. Om du skapar ett mätbesked kommer det att skapas/beställas direkt och skickas av Biometria till leverantören.</rask-info></rask-action-button>
                @if(vm.requestingMatbesked){
                    <rask-busy-spinner class="ms-1" size="1"></rask-busy-spinner>
                    }
        <span>{{vm.matbesked.senastBegard | date: "yyyy-MM-dd hh:mm:ss"}}</span>
    </div>
        }
    @if(vm.matbesked.message){
    <rask-validation-message-row
        class="mt-2 p-0"
        type="error"
        [message]="vm.matbesked.message">
    </rask-validation-message-row>
    }
</div>
}